import type { CityConfig } from "../city-template/types";

export const fairfieldConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Butler County Probate Court", href: "https://www.butlercountyohio.org/probate-court", description: "Butler County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Butler County Clerk of Courts", href: "https://www.butlercountyohio.org/clerk-of-courts", description: "Butler County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Fairfield",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "fairfield",
  route: "/fairfield-oh",
  title: "Emergency Passport Fairfield, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fairfield, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Butler and Hamilton Counties. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Fairfield, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fairfield and Butler County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fairfield%20Ohio%20suburban%20cityscape%20at%20golden%20hour%20with%20modern%20commercial%20district%20and%20tree-lined%20residential%20neighborhoods%2C%20wide%20boulevards%20with%20green%20parks%20and%20well-maintained%20suburban%20homes%2C%20warm%20sunset%20light%20on%20civic%20buildings%20and%20shopping%20centers%2C%20Cincinnati%20suburb%20atmosphere%20with%20rolling%20hills%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20clear%20sky&width=1800&height=700&seq=fairfield-oh-hero-001&orientation=landscape",
  heroImageAlt: "Fairfield Ohio suburban cityscape with commercial district at golden hour",
  geoPosition: "39.3459;-84.5605",
  geoPlacename: "Fairfield, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles from Fairfield via I-74",
  },
  nearbyCitiesZips: [
    { name: "Fairfield", zips: "45014, 45018" },
    { name: "Hamilton", zips: "45011, 45012, 45013, 45015" },
    { name: "West Chester", zips: "45069, 45071" },
    { name: "Mason", zips: "45040" },
    { name: "Liberty Township", zips: "45011, 45044" },
    { name: "Monroe", zips: "45050" },
    { name: "Ross", zips: "45013, 45014" },
    { name: "Cincinnati", zips: "45201–45275" },
    { name: "Sharonville", zips: "45241" },
    { name: "Springdale", zips: "45246" },
    { name: "Forest Park", zips: "45240" },
    { name: "Blue Ash", zips: "45241, 45242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Fairfield departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Cincinnati Suburb Coverage", desc: "Serving Butler and Hamilton Counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cincinnati, OH", route: "/cincinnati" },
    { name: "Fast passport renewal in Hamilton, OH", route: "/hamilton-oh" },
    { name: "Emergency passport help in Dayton, OH", route: "/dayton" },
    { name: "Urgent passport services in Middletown, OH", route: "/middletown-oh" },
    { name: "Same-day passport help in Mason, OH", route: "/cincinnati" },
    { name: "Passport courier services in West Chester, OH", route: "/cincinnati" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fairfield remotely via secure courier. We do not have a walk-in office in Fairfield — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Butler and Hamilton County travelers.",
  fpcOfficeDistance: "Serving all of Butler and Hamilton Counties",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From Fairfield to Hamilton, West Chester, and Mason — Fast Passport Center serves the entire Butler and Hamilton County region. We regularly help travelers from Liberty Township, Monroe, and the northern Cincinnati suburbs get their passports fast.",
  nearbyCitiesIntro: "We serve all Fairfield neighborhoods and the surrounding Butler and Hamilton County region including Hamilton, West Chester, Mason, Liberty Township, Monroe, Ross, Cincinnati, Sharonville, Springdale, Forest Park, and Blue Ash. If you are anywhere in the northern Cincinnati suburbs, we have you covered.",
  howItWorksIntro: "Most Fairfield travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Fairfield travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fairfield and Butler County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fairfield? Here are the most common ones we hear from Butler County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Fairfield international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Steven M.",
      location: "Fairfield, OH",
      rating: 5,
      text: "My passport expired just before a business trip to London. Fast Passport Center had my renewal ready in 4 days. They guided me through every step and made it completely stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Karen L.",
      location: "Hamilton, OH",
      rating: 5,
      text: "I thought I'd have to drive to Chicago or wait weeks for an emergency passport. Fast Passport Center handled everything remotely — got mine in 36 hours. Absolutely saved my trip.",
      service: "Emergency Passport",
    },
    {
      name: "Brian T.",
      location: "West Chester, OH",
      rating: 5,
      text: "Family cruise to the Caribbean and my son's passport was expired. They found us the nearest acceptance facility and had his passport in 5 days. Couldn't be happier with the service.",
      service: "Child Passport",
    },
    {
      name: "Diana R.",
      location: "Mason, OH",
      rating: 5,
      text: "Last-minute business trip to Germany with only 6 days notice. Fast Passport Center delivered my passport in 3 business days. Professional team and excellent communication throughout.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "fairfield-1",
      name: "Fairfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Miller Dr",
      city: "Fairfield",
      state: "OH",
      zip: "45014",
      phone: "(513) 829-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fairfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main facility serving Fairfield and Butler County. High volume — appointments recommended. Multiple windows available.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfield-2",
      name: "Hamilton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1010 S Erie Hwy",
      city: "Hamilton",
      state: "OH",
      zip: "45011",
      phone: "(513) 887-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hamilton, east of Fairfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hamilton and eastern Butler County residents. Less crowded than Fairfield. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfield-3",
      name: "West Chester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7778 Cincinnati-Dayton Rd",
      city: "West Chester",
      state: "OH",
      zip: "45069",
      phone: "(513) 759-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Chester, north of Fairfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Excellent option for northern Butler County residents. Easier parking than downtown Cincinnati.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfield-4",
      name: "Mason Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "318 Reading Rd",
      city: "Mason",
      state: "OH",
      zip: "45040",
      phone: "(513) 398-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mason, northeast of Fairfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mason, Monroe, and northeastern Butler County residents. Ample parking. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfield-5",
      name: "Butler County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "315 High St",
      city: "Hamilton",
      state: "OH",
      zip: "45011",
      phone: "(513) 887-3278",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Butler County Courthouse",
      website: "https://www.butlercountyohio.org/",
      websiteLabel: "Butler County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "fairfield-6",
      name: "Sharonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11515 Lebanon Rd",
      city: "Sharonville",
      state: "OH",
      zip: "45241",
      phone: "(513) 769-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sharonville, north of Fairfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Hamilton County and southern Butler County. Appointments required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fairfield photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Butler County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fairfield applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Butler County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fairfield travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fairfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fairfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fairfield before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fairfield for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Fairfield?", a: "Fast Passport Center offers fast passport renewal in Fairfield in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Fairfield?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 300 miles from Fairfield — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Butler County residents." },
    { q: "Can I expedite a child passport in Fairfield?", a: "Yes. Fast Passport Center expedites child passports in Fairfield for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Butler County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fairfield with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Fairfield?", a: "The nearest regional passport agency to Fairfield is the Chicago Passport Agency, approximately 300 miles away via I-74. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Fairfield without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "How do I find a passport acceptance facility near Fairfield?", a: "Butler and Hamilton Counties have several passport acceptance facilities including the Fairfield Post Office, Hamilton Main Post Office, West Chester Post Office, Mason Post Office, Sharonville Post Office, and the Butler County Clerk of Courts. We can help you locate the most convenient facility and schedule your appointment." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fairfield", address: "5430 Dixie Hwy, Fairfield, OH 45014", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fairfield", address: "3401 Princeton Rd, Fairfield, OH 45014", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Fairfield", address: "3201 Princeton Rd, Fairfield, OH 45014", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Fairfield", address: "5150 Dixie Hwy, Fairfield, OH 45014", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "CVS Pharmacy — Hamilton", address: "1180 S Erie Hwy, Hamilton, OH 45011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — West Chester", address: "7790 Cincinnati-Dayton Rd, West Chester, OH 45069", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Mason", address: "5120 Bowen Dr, Mason, OH 45040", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Sharonville", address: "11550 Lebanon Rd, Sharonville, OH 45241", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Butler County BMV — Fairfield",
      address: "8098 US Hwy 27, Fairfield, OH 45014",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "BMV License Agency — Hamilton",
      address: "1010 S Erie Hwy, Hamilton, OH 45011",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Hamilton and eastern Butler County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "BMV License Agency — West Chester",
      address: "8200 Princeton-Glendale Rd, West Chester, OH 45069",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Convenient for West Chester, Mason, and northern Butler County residents.",
      featured: false,
    },
    {
      name: "AAA — Fairfield",
      address: "3401 Princeton Rd, Fairfield, OH 45014",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "30 miles southwest of Fairfield",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub serving the Greater Cincinnati area. Delta hub with direct flights to Europe, Mexico, and the Caribbean. Most convenient for Fairfield travelers.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: true,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "35 miles north of Fairfield",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative airport for north Butler County residents. Easier parking and security than CVG during peak periods.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "110 miles northeast of Fairfield",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};